<template>
    <div class="main-wrapper">
        <el-row type="flex" class="mb-1 align-center">
            <b class="section-subheader">User</b>
        </el-row>
        <el-row>
            <span>{{ staticName }} users are matched with {{ integrationNameWithCasing }} users using their email addresses as the unique identifier.</span>
        </el-row>

        <el-row :gutter="20" class="mt-3">
            <!-- Start Aloware and HubSpot Labels -->
            <el-col :span="10" class="mb-1">
                <small>{{ staticName }}</small>
            </el-col>
            <el-col :span="4" class="mb-1 text-center">
                <small>Direction</small>
            </el-col>
            <el-col :span="10" class="mb-1">
                <small>{{ integrationNameWithCasing }}</small>
            </el-col>
            <!-- End Aloware and HubSpot Labels -->
        </el-row>

        <el-row v-for="(operation, index) in this.model.settings.mapper_settings.user" :key="operation.internal_value" :gutter="20" type="flex" align="middle" class="mb-3">
            <!-- Start Aloware Fields -->
            <el-col :span="10">
                <el-input readonly :value="operation.internal_label" class="w-100"/>
            </el-col>
            <!-- End Aloware Fields -->

            <el-col :span="4" class="text-center">
                <el-tooltip
                    v-if="operation.direction_fixed"
                    content="Direction on User Syncing Prefences cannot be changed."
                    placement="top"
                    effect="dark"
                >
                    <direction-selector
                        :initial-state="operation.direction"
                        @change="direction => updateDirection(index, direction)"
                        :disabled="operation.direction_fixed"
                    >
                    </direction-selector>
                </el-tooltip>
                <direction-selector
                    v-else
                    :initial-state="operation.direction"
                    @change="direction => updateDirection(index, direction)"
                    :disabled="operation.direction_fixed"
                >
                </direction-selector>
            </el-col>

            <!-- Start CRM Fields -->
            <el-col :span="10">
                <el-input
                    readonly
                    :value="operation.crm_label"
                    class="w-100"
                />
            </el-col>
            <!-- End CRM Fields -->
        </el-row>
    </div>
</template>

<script>
import DirectionSelector from '../direction-selector.vue'

export default {
    components: {
        DirectionSelector,
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        integrationNameWithCasing: {
            type: String,
            required: true
        },
        staticName: {
            type: String,
            required: true
        }
    },
    methods: {
        updateDirection(index, direction) {
            this.model.settings.mapper_settings.user[index].direction = direction
        }
    }
}
</script>

<style scoped>
.main-wrapper {
    width: 100%;
}

.section-subheader {
    font-size: 16px;
}

.w-100 {
    width: 100%;
}

.align-center {
    align-items: center;
}
</style>
